import { META_KEY } from 'contracts/constants';
import type { ICollectionType, IField } from 'contracts/interfaces';

export const isCollection = (schema: ICollectionType | IField): schema is ICollectionType =>
  typeof schema === 'object' ? META_KEY in schema : false;
